$(document).ready(function () {

    //scroll to links
    $(".stories-link").click(function (e) {
        e.preventDefault();
        $('html, body').animate({
            scrollTop: $("#stories").offset().top
        }, 1000);
    });

    $(".skip").click(function (e) {
        e.preventDefault();
        $('html, body').animate({
            scrollTop: $("#content-main").offset().top
        }, 1000);
    });


    $('.top-link a, a.back-to-top-link').click(function (e) {
        e.preventDefault();
        $("html, body").animate({ scrollTop: 0 }, 1000);
    });


    //contact show and hide
    $(".contact-link").on('click', function (e) {
        $('html').css('overflow-y', 'hidden');
        e.preventDefault();
        var contact = $(this).attr('href');
        $(contact).slideToggle('fast');
    });

    $(".close-contact").on('click', function (e) {
        $('html').css('overflow-y', 'auto');
        e.preventDefault();
        var contact = $(this).attr('href');
        $('#DisplayContact').find('input:text').val('');
        $('.Messagetext').val('');
        $('.success-message').hide();
        $('#DisplayContact').show();
        $(contact).slideToggle('fast');
    });

    //contact send message
    $("form.contact-form").submit(function (e) {
        if ($("input[name=maps]").val().length == 0) {
            $.ajax({
                type: "POST",
                url: "/ajax/ContactUsSend.aspx",
                data: {
                    Name: $("input[name=name]", this).val(),
                    Email: $("input[name=email]", this).val(),
                    Phone: $("input[name=phone]", this).val(),
                    Message: $("textarea[name=message]", this).val()
                },
                success: function (response) {
                    if (response.indexOf("ERROR: ") != -1) {
                        alert(response.replace("ERROR: ", ""));
                    }
                    else {
                        $('#DisplayContact').hide();
                        $("<div>")
                            .addClass("success-message")
                            .text(response.replace("SUCCESS: ", ""))
                            .appendTo("form.contact-form");
                    }
                }
            });
        } else {
            $('#DisplayContact').hide();
        }

        return false;
    });

    //subscribe to newsletter
    $(".news-signup-form form").submit(function (e) {
        $.ajax({
            type: "POST",
            url: "/ajax/Subscribe.aspx",
            data: {
                FirstName: $("input[name=firstname]", this).val(),
                LastName: $("input[name=lastname]", this).val(),
                EmailAddress: $("input[name=emailaddress]", this).val()
            },
            success: function (response) {
                if (response.indexOf("ERROR: ") != -1) {
                    alert(response.replace("ERROR: ", ""));
                }
                else {

                    var sm = $("<div>")
                        .addClass("success-message")
                        .text(response.replace("SUCCESS: ", ""))

                    $('.news-signup-form form').empty().append(sm);

                }
            }
        });


        return false;
    });

    //toggle links
    $(".toggle").on('click', function (e) {
        e.preventDefault();
        var nav = $(this).attr('href');

        $(nav).slideToggle('fast');
    });

    //    locations show/hide sections
    $('ul#loc-menu.location-page li.view a, ul#loc-menu.detail li a').click(function (e) {
        if ($(e.target).parent().hasClass('book-link') === false) {
            e.preventDefault();
            var go = $(this).attr('href').split('#');

            $('ul#loc-menu li.active').removeClass('active');
            $(this).parent().addClass('active');

            $('div.reveal:visible').removeClass("is-visible");
            $('#' + go[1]).addClass("is-visible");

            //details-view has two other associated div's but they cannot be combined due to responsive design.
            //We need to show them too
            if (go[1] === 'details-view') {
                $('#details-main').addClass('active');
                $('#details-main').addClass("is-visible");
                $('#details-header').addClass("is-visible");
            }

            //Header is positioned above the menu when in mobile so it is always visible
            if ($(window).width() <= 500) {
                $('#details-header').addClass("is-visible");
            }
        }
    });

    //open up the reviews tab when clicking on the reviews link in the details summary
    $('#details-header a[href="#reviews-view"]').click(function (e) {
   
        e.preventDefault();
        $('ul#loc-menu li.active').removeClass('active');
        $('#loc-menu a[href="#reviews-view"]').first().parent().addClass('active');
        $('div.reveal:visible').removeClass("is-visible");
        $('#reviews-view').addClass("is-visible");
        if ($(window).width() <= 500) {
            $('#details-header').addClass("is-visible");
        }
        document.querySelector(".details-options").scrollIntoView({ behavior: "smooth", block: "start", inline: "nearest" });
    });


    //Form input placeholder text fallback for older browsers
    if (!Modernizr.input.placeholder) {

        $('[placeholder]').focus(function () {
            var input = $(this);
            if (input.val() == input.attr('placeholder')) {
                input.val('');
                input.removeClass('placeholder');
            }
        }).blur(function () {
            var input = $(this);
            if (input.val() == '' || input.val() == input.attr('placeholder')) {
                input.addClass('placeholder');
                input.val(input.attr('placeholder'));
            }
        }).blur();
        $('[placeholder]').parents('form').submit(function () {
            $(this).find('[placeholder]').each(function () {
                var input = $(this);
                if (input.val() == input.attr('placeholder')) {
                    input.val('');
                }
            })
        });

    }
});
